<template>
  <div class="inputFrom">
    <!-- <el-card shadow="hover"> -->
    <el-form
      :inline="true"
      ref="formSearch"
      :model="form"
      label-width="120px"
      :label-position="labelPosition"
    >
      <span v-for="(item,idx) in inputData" :key="idx">
        <!-- 隐藏占位 -->
        <el-form-item v-if="item.seize" style="opacity: 0;" class="seize">
          <div :style="item.width ? item.width : 'width:280px;'"></div>
        </el-form-item>

        <!-- 下拉选择框 -->
        <el-form-item v-else-if="item.selectArr" :label="item.name">
          <el-select
            size="small"
            v-model="form[item.val]"
            :placeholder="item.placeholder ? item.placeholder : item.name"
            :style="item.width ? 'width:' + item.width + 'px' : 'width:280px;'"
          >
            <!-- <el-option  label="全部" value=""></el-option> -->
            <el-option v-for="(k,i) in item.selectArr" :label="k.label" :value="k.id" :key="i"></el-option>
          </el-select>
          <template v-if="item.children">
            <span style="margin:15px"></span>
            <el-input
              size="small"
              v-model="form[item.children[0].val]"
              :placeholder="item.children[0].placeholder ? item.children[0].placeholder : ''"
              send_channel_shunt
              style="width: 125px;"
            ></el-input>
          </template>
        </el-form-item>
        <!-- 单选框 -->
        <el-form-item v-else-if="item.radioArr" :label="item.name">
          <el-radio-group size="small" v-model="form[item.val]" @change="redioActive">
            <template v-for="(k,i) in item.radioArr">
              <el-radio v-if="k.children" :label="k.label" :key="i">
                {{k.val}}
                <!-- 内嵌日期选择组件 -->
                <span>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form[k.children[0].val[0]]"
                    type="datetime"
                    :placeholder="item.startPlaceholder || '选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 120px; display: inline-block;font-size:12px"
                    class="time1"
                    :disabled="dis"
                    :clearable="false"
                  ></el-date-picker>
                  <span class="time_to_text">至</span>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form[k.children[0].val[1]]"
                    type="datetime"
                    :disabled="dis"
                    :placeholder="item.endPlaceholder || '选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 145px;display: inline-block;font-size:12px"
                    class="time2"
                    :clearable="false"
                  ></el-date-picker>
                </span>
              </el-radio>
              <el-radio v-else :label="k.label" :key="i">{{k.val}}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>

        <!-- 双下拉选择框，联动 -->
        <el-form-item v-else-if="item.selectArrDouble" :label="item.name">
          <div style="width:280px">
            <el-select
              size="small"
              v-model="form[item.selectArrDouble[0].val]"
              :placeholder="item.selectArrDouble[0].placeholder ? item.selectArrDouble[0].placeholder : item.selectArrDouble[0].name"
              style="width: 116px;margin-right: 8px"
            >
              <el-option label="全部" value></el-option>
              <el-option
                v-for="(k,i) in item.selectArrDouble[0].selectArr"
                :label="k.label"
                :value="k.id"
                :key="i"
              ></el-option>
            </el-select>
            <el-select
              v-if="form[item.selectArrDouble[0].val] == item.showSelect2Id"
              size="small"
              v-model="form[item.selectArrDouble[1].val]"
              :placeholder="item.selectArrDouble[1].placeholder ? item.selectArrDouble[1].placeholder : item.selectArrDouble[1].name"
              style="width: 155px;"
            >
              <el-option label="全部" value></el-option>
              <el-option
                v-for="(k,i) in item.selectArrDouble[1].selectArr"
                :label="k.label"
                :value="k.id"
                :key="i"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>

        <!-- input、日期选择器 -->
        <el-form-item v-else :label="item.name">
          <!-- 时间插件 -->
          <el-date-picker
            v-if="item.dateVal"
            :default-time="item.defaultTime ||''"
            :type="item.type?item.type:'datetime'"
            :range-separator="item.range ? item.range : '至'"
            :value-format=" item.valueFormat || 'yyyy-MM-dd HH:mm:ss' "
            :placeholder=" item.placeholder ? item.placeholder : '' "
            :start-placeholder="item.startPlaceholder ? item.startPlaceholder : '开始日期'"
            :end-placeholder="item.endPlaceholder ? item.endPlaceholder : '结束日期'"
            @input="immediUpdate"
            size="small"
            v-model="form[item.val]"
          ></el-date-picker>
          <div class="my_select_time" v-else-if="item.myDate">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form[item.val[0]]"
              type="datetime"
              :placeholder="item.startPlaceholder || '选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:120px;font-size:12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form[item.val[1]]"
              type="datetime"
              :placeholder="item.endPlaceholder || '选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:145px;font-size:12px"
              class="time2"
              :clearable="false"
            ></el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime(item.val[0], item.val[1])"></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          <!-- input表单 -->
          <template v-else-if="item.iptArr">
            <span v-for="(data, index) in item.iptArr" :key="index">
              <span v-if="index > 0">&nbsp; 至 &nbsp;</span>
              <el-input
                size="small"
                send_channel_shunt
                style="width: 125px;"
                v-model="form[data.val]"
                :maxlength="data.maxlength"
                :placeholder="data.placeholder ? data.placeholder : data.name"
              ></el-input>
            </span>
          </template>

          <el-input
            v-else
            size="small"
            send_channel_shunt
            :style="item.width ? 'width:' + item.width + 'px' : 'width:280px;'"
            v-model="form[item.val]"
            :maxlength="item.maxlength"
            :placeholder="item.placeholder ? item.placeholder : item.name"
          ></el-input>
        </el-form-item>

        <!-- 查询、重置按钮位置-->
        <el-form-item v-if="btnPosition && idx === (inputData.length - 1)">
          <div style="marginLeft: 42px;">
            <el-button size="small" class="search" type="primary" v-zoom='{from:pageName,name:"查询"}' @click="submitForm('formSearch')">
              <i
                class="el-icon-search"
                style="display:inline-block;width:14px;height:12px;"
              ></i> 查询
            </el-button>
            <el-button
              size="small"
              class="reset"
              type="primary"
              @click="resetForm"
              v-if="reset!='1'"
            >重置</el-button>
          </div>
        </el-form-item>
      </span>
    </el-form>
    <div class="el_btn" v-if="!btnPosition">
      <el-button size="small" class="search" type="primary" v-zoom='{from:pageName,name:"查询"}' @click="submitForm('formSearch')">
        <i
          class="el-icon-search"
          style="display:inline-block;width:14px;height:12px;"
        ></i> 查询
      </el-button>
      <el-button size="small" class="reset" type="primary" @click="resetForm" v-if="reset!='1'">重置</el-button>
    </div>
    <!-- </el-card> -->
  </div>
</template>

<script>
export default {
  name: "inputForm",
  props: {
    // selectArr（下拉组件值），seize（占位）
    pageName:{
      type:String,
      default:"表单查询"
    },
    inputData: {
      type: Array,
    },
    btnPosition: {
      type: Boolean,
      default: false,
    },
    reset: {
      type: String,
    },
    labelPosition: {
      type: String,
      default: "right",
    },
    time: {
      type: Number,
    },
    one: {
      type: Number,
    },
  },

  data() {
    return {
      form: {
        current: 1,
        size: 20,
      },
      totalCount: 0,
      list: [],
      dis: true,
    };
  },
  watch: {
    immediate: true,
    one: {
      handler(newName, oldName) {
        console.log(newName, oldName); // ...
      },
    },
  },
  created() {
    this.initVal();
  },
  mounted() {
    if (this.time == 1) {
      this.form.orderStartTimeStart = this.getDateStr(-30) + " 00:00:00";
      this.form.orderStartTimeEnd = this.getDateStr(0) + " 23:59:59";
    }
    // console.log(this.one)
  },
  methods: {
    initVal() {
      // 表单初始值处理
      let inputData = this.inputData;
      for (let item of inputData) {
        if (item.children) {
          let childItem = item.children[0];
          // console.log(childItem);
          this.$set(this.form, childItem.val, "");
          // if (childItem.myDate) {
          //     if (Array.isArray(key)) {
          //         this.$set(this.form, childItem.val[0], null);
          //         this.$set(this.form, childItem.val[1], null);
          //     }
          // }
        }
        if (item.radioArr) {
          for (let items of item.radioArr) {
            if (items.children) {
              if (items.children[0].myDate) {
                let childItem = items.children[0];
                this.$set(this.form, childItem.val[0], "");
                this.$set(this.form, childItem.val[1], "");
              }
            }
          }
          // let childItem = item.children[0]
          // console.log(childItem);
          // if (childItem.myDate) {
          //     if (Array.isArray(key)) {
          //         this.$set(this.form, childItem.val[0], "");
          //         this.$set(this.form, childItem.val[1], "");
          //     }
          // }
        }
        if (item.iptArr) {
          if (Array.isArray(item.iptArr)) {
            for (let i of item.iptArr) {
              this.$set(this.form, i.val, null);
            }
          }
        } else {
          let key = item["val"];
          if (typeof item["initVal"] != "undefined") {
            let val = item["initVal"];
            this.$set(this.form, key, val);
          } else if (typeof key != "undefined") {
            if (item.default) {
              this.$set(this.form, key, item.default);
            } else {
              this.$set(this.form, key, "");
            }
          }

          if (item.myDate) {
            if (Array.isArray(key)) {
              this.$set(this.form, key[0], null);
              this.$set(this.form, key[1], null);
              delete this.form[key];
            }
          }
        }
      }
    },
    submitForm(formName) {
      //查询表单前端验证
      let self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.bus.$emit("pageto", this.form);
          this.form.current = 1;
          self[formName]();
        } else {
          return false;
        }
      });
    },
    formSearch() {
      //搜索
      this.$emit("toParentVal", this.form);
    },
    resetForm() {
      // 重置
      for (let k in this.form) {
        this.form[k] = "";
      }
      this.form = {
        current: 1,
        size: 20,
      };
      this.initVal();
    },
    immediUpdate(e) {
      // if (!e) {
      //     delete this.form.creatTimeEnd
      //     delete this.form.creatTimeStart
      // }
    },
    clearTime(a, b) {
      this.form[a] = null;
      this.form[b] = null;
    },
    // 单选框change事件，赶时间先写死了
    redioActive(val) {
      // 单选框label选择到custom，解锁dete组件
      if (val === "custom") {
        this.dis = false;
      } else {
        this.dis = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/.my_select_time .el-input__inner {
//   padding: 0px 8px !important;
//   font-size: 11px;
// }
.inputFrom {
  .el_btn {
    text-align: center;
  }
  .my_select_time {
    display: flex;
    align-items: center;
  }
  .search,
  .reset {
    font-size: 14px;
    border-radius: 3px;
    width: 98px !important;
    height: 32px !important;
    transition: all 0.2s;
  }
  .search {
    color: #fe4d45;
    font-size: 14px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(254, 77, 69, 1);
    &:hover {
      background-color: #fe4d45;
      color: #fff;
    }
  }
  .reset {
    color: #000;
    font-size: 14px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
    &:hover {
      border: 1px solid #fe4d45;
      color: #fe4d45;
    }
  }
  @media screen and (max-width: 1720px) {
    .seize {
      display: none;
    }
  }
}
</style>
<style lang="scss">
.inputFrom {
  .el-card__body {
    padding: 20px 20px 30px 20px;
  }
  .el-range-editor.el-input__inner {
    padding: 3px 6px;
  }
  .el-date-editor .el-range-separator {
    padding: 0;
  }
  .el-date-editor {
    display: flex;
    justify-content: space-between;
    .el-range-input {
      width: 24%;
      overflow: hidden;
    }
  }
  .el-form-item__label {
    white-space: nowrap;
  }
}
</style>